<template>
	<div id="app">
		<transition name="appani">
			<router-view/>
		</transition>
		<videoDialog ref='videoDialog'/>
		<Dialogbox ref='dialogbox'/>
		<dialogMedia ref='dialogMedia'/>
		<qrcode ref='qrcode'/>
	</div>
</template>

<script>
	import dialogMedia from "@/components/dialog/media"
	import qrcode from "@/components/qrcode/qrcode"
	import videoDialog from "@/components/dialog/video_dialog"
	import Dialogbox from "@/components/dialog/dialog"
	export default {
		components:{dialogMedia,qrcode,videoDialog,Dialogbox,},
		name: 'App',
		mounted(){
			window.$dialog = this.$refs.dialogbox;
			window.$v_dialog = this.$refs.videoDialog;
		}
	}
</script>

<style>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue